import { Card, CardBody, CardHeader, CardHeading, FCC } from "@dgs/core";
import { useId } from "react";
import styled from "styled-components";

const StyledCardBody = styled(CardBody)`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: ${({ theme }) => theme.spacing(5)};
`;

interface Props {
	title: string;
}

export const AffiliationCountCard: FCC<Props> = ({ title, children }) => {
	const labelId = useId();

	return (
		<Card aria-labelledby={labelId}>
			<CardHeader>
				<CardHeading id={labelId}>{title}</CardHeading>
			</CardHeader>
			<StyledCardBody>{children}</StyledCardBody>
		</Card>
	);
};
